<app-time-off-section>
    <div class="time-off-shell">
        <nav class="tab-navigation" aria-label="Time Off sections">
            <ng-container *ngFor="let item of navList">
                <a
                    *appHasFeature="item.featureCode"
                    mat-button
                    class="tab-link"
                    setColor
                    [setColorRules]="[
                        {
                            color: 'primaryColour',
                            style: 'color',
                            events: ['hover']
                        },
                        {
                            color: 'primaryColour',
                            style: 'border-bottom-color',
                            setIfClass: ['active'],
                            events: ['routerLinkActive']
                        },
                        {
                            color: 'primaryColour',
                            style: 'color',
                            setIfClass: ['active'],
                            events: ['routerLinkActive']
                        }
                    ]"
                    [routerLink]="item.link"
                    routerLinkActive="active"
                    appLocalizationPopupDirective
                    [localizationCode]="item.text"
                >
                    <ng-container *ngIf="item.svg; else iconTemplate">
                        <svg xmlns="http://www.w3.org/2000/svg" class="mat-icon">
                            <image [attr.href]="item.svg" width="100%" height="100%"/>
                        </svg>
                    </ng-container>
                    <ng-template #iconTemplate>
                        <mat-icon class="material-icons-outlined">{{ item.icon }}</mat-icon>
                    </ng-template>
                    <span class="text">{{ translate.instant(item.text) }}</span>
                </a>
            </ng-container>
        </nav>

        <div class="content">
            <ng-content></ng-content>
        </div>
    </div>
</app-time-off-section>
